import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { BaseComponent } from "@copec-gid/gid-arquitectura.tema-default-a16/left-light"
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';
//MODULO DE SEGURIDAD QUE PUEDE CAMBIAR SEGUN EL TIPO
// import { HTTPService, InterceptorCopecService } from '@copec-gid/utilitarios-base-modulo-a16';

import { ConfMonitor, AuthGuard, Sidenav } from '@copec-gid/monitor-mkt.utilitarios-monitor-modulo';
import { ConfProyecto } from '@copec-gid/gid-arquitectura.utilitarios-base-modulo-a16';
import { OriginsTypes } from '@copec-gid/monitor-mkt.cupones-monitor-modulo/lib/core/interfaces/origins-types';

const routes: Routes = [
  {
    path: '',
    //TODO: BaseComponent puede ser modificado o quitado es el que tiene el diseño con un menú izquierdo y superior
    component: BaseComponent,
    canActivate: [AuthGuard],
    data: {
      obtenerMenu: () => Sidenav.menuByPermission(),
      // llamarApiLogout: () => ConfProyecto.llamarApiLogout(),
      urlLogout: () => ConfProyecto.pathLogin,
      nombreAplicacion: () => ConfProyecto.nombreAplicacion,

      // urlPerfil: () => ConfProyecto.pathPerfil,
    },
    children: [
      /**
        TODO: aqui se deben cargar todos los modulos que necesitan sesion, se debe configurar el path por default si no viene ruta
       */
      { path: '', redirectTo: 'principal', pathMatch: 'full' },// definicion de la ruta principal
      {
        path: 'principal',
        loadChildren: () => import('./views/pages/principal/principal.module').then(m => m.PrincipalModule),
      },
      {
        path: 'mantenedor-usuarios',
        loadChildren: () => import('@copec-gid/monitor-mkt.mantenedor-monitor-modulo-a16').then(m => m.UsersModule),
      },
      {
        path: 'empresas',
        loadChildren: () => import('@copec-gid/monitor-mkt.empresas-monitor-modulo-a16').then(m => m.CompanyListModule),
      },
      {
        path: 'carga-masiva',
        loadChildren: () => import('@copec-gid/monitor-mkt.cargamasiva-monitor-modulo-a16').then(m => m.GlobalBulkUploadModule),
      },
      {
        path: 'banners',
        loadChildren: () => import('@copec-gid/monitor-mkt.banners-monitor-modulo-a16').then(m => m.BannersModule),
      },
      {
        path: 'cupones',
        loadChildren: () => import('@copec-gid/monitor-mkt.cupones-monitor-modulo').then(m => m.GlobalCouponsModule),
      },
      {
        path: 'catalogo',
        loadChildren: () => import('@copec-gid/monitor-mkt.catalogo-productos-monitor-modulo').then(m => m.CatalogProductsModule),
      },
      {
        path: 'promociones',
        loadChildren: () => import('@copec-gid/monitor-mkt.promociones-monitor-modulo').then(m => m.PromotionsModule),
      },
      {
        path: 'misiones',
        loadChildren: () => import('@copec-gid/monitor-mkt.misiones-monitor-modulo').then(m => m.MissionsModule),
      },
      {
        path: 'catalogo',
        loadChildren: () => import('@copec-gid/monitor-mkt.catalogo-productos-monitor-modulo').then(m => m.CatalogProductsModule),
      },
      {
        path: 'catalogo-tickets',
        loadChildren: () => import('@copec-gid/monitor-mkt.canje-experiencia-monitor-modulo').then(m => m.CatalogTicketsModule),
      },
      {
        path: 'codigos',
        loadChildren: () => import('@copec-gid/monitor-mkt.codigos-monitor-modulo').then(m => m.CodesModule),
      },
      {
        path: 'aliados',
        loadChildren: () => import('@copec-gid/monitor-mkt.aliados-monitor-modulo').then(m => m.AlliesModule),
      },
      // {
      //   path: 'notificaciones',
      //   loadChildren: () => import('@copec-gid/monitor-mkt.notificaciones-monitor-modulo-a16').then(m => m.NotificationsModule),
      // },
    ]
  },
  // TODO: puede comentar esta linea o modificarla si no necesita el modulo de autenticacion de google
  { path: 'login', loadChildren: () => import('@copec-gid/monitor-mkt.autenticacion-monitor-modulo-a16').then(m => m.AuthModule) },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Página No Encontrada',
      'desc': '¡Vaya! La página que estabas buscando no existe.'
    }
  },
  {
    path: 'wait',
    component: PageWaitComponent
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
